var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsolation2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1047 103.305V177.875L125.685 225.145V157.525L80.8947 78.8448L36.1047 103.305Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.395 116.675C216.255 135.455 216.125 154.235 216.005 173.015C185.905 190.375 155.795 207.755 125.695 225.125V157.505C155.925 143.925 186.165 130.295 216.395 116.675Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.635 163.415V230.495L125.685 225.145V157.525L136.635 163.415Z",
    fill: "#FECECA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.635 230.495L217.815 183.145L216.615 124.815L136.635 163.415V230.495Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.575 95.3748C25.095 98.0148 30.6049 100.665 36.1249 103.305L80.9149 78.8447C100.975 107.835 121.015 136.815 141.075 165.805C171.175 149.465 201.275 133.145 231.365 116.815C211.385 84.8747 191.425 52.9147 171.445 20.9747C141.275 34.3347 111.095 47.6847 80.9149 61.0347C60.4549 72.4847 40.005 83.9448 19.575 95.3748Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.575 95.3749L36.1049 103.305L80.895 78.8448L125.685 157.525L141.055 165.805L80.895 61.0548L19.575 95.3749Z",
    fill: "#B2E8C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7049 99.755C31.1849 100.935 33.6449 102.125 36.1249 103.305V177.875C33.6449 176.425 31.1849 174.985 28.7049 173.535C28.6849 148.945 28.7049 124.345 28.7049 99.755Z",
    fill: "#FECECA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1047 177.875L112.565 134.465L80.8947 78.8448L36.1047 103.305V177.875Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolation2);
export default __webpack_public_path__ + "static/media/isolation2.954075fb69a6db01d3d3149a92617852.svg";
export { ForwardRef as ReactComponent };